function validation() {
  const name = document.getElementById("name");
  const name_er = document.getElementById("name_er");
  const kana = document.getElementById("kana");
  const kana_er = document.getElementById("kana_er");
  const post = document.getElementById("post");
  const post_er = document.getElementById("post_er");
  const add_1 = document.getElementById("add_1");
  const add_1_er = document.getElementById("add_1_er");
  const add_2 = document.getElementById("add_2");
  const add_2_er = document.getElementById("add_2_er");
  const add_3 = document.getElementById("add_3");
  const add_3_er = document.getElementById("add_3_er");
  const tel = document.getElementById("tel");
  const tel_er = document.getElementById("tel_er");
  const mail = document.getElementById("mail");
  const mail_er = document.getElementById("mail_er");
  const text = document.getElementById("text");
  const text_er = document.getElementById("text_er");

  //name
  let clear = [];
  if (name !== null) {
    let name_arr = [];
    if (name.value === "") {
      name_arr.push("入力必須です。");
    }
    if (name.value.length > 20) {
      name_arr.push("20文字以内で入力してください。");
    }
    if (name.value.match(/^[ぁ-んァ-ヶｱ-ﾝﾞﾟ一-龠a-zA-Zａ-ｚＡ-Ｚ\s]*$/) === null) {
      name_arr.push("数字や記号は入力できません");
    }
    if (name_arr.length !== 0) {
      name.classList.add("b-formInput__error");
      name_er.textContent = name_arr.join("／");
      clear.push("name");
    } else {
      name.classList.remove("b-formInput__error");
    }
  }
  //kana
  if (kana !== null) {
    let kana_arr = [];
    if (kana.value === "") {
      kana_arr.push("入力必須です。");
    }
    if (kana.value.length > 40) {
      kana_arr.push("30文字以内で入力してください。");
    }
    if (kana.value.match(/^[ぁ-ゞ 　]*?[ぁ-ゞ]+?[ぁ-ゞ 　]*?$/u) === null) {
      kana_arr.push("ひらがなで入力してください");
    }
    if (kana_arr.length !== 0) {
      kana.classList.add("b-formInput__error");
      kana_er.textContent = kana_arr.join("／");
      clear.push("kana");
    } else {
      kana.classList.remove("b-formInput__error");
    }
  }
  //postcode
  if (post !== null) {
    let post_arr = [];
    if (post.value === "") {
      post_arr.push("入力必須です。");
    }
    if (post.value.length > 7) {
      post_arr.push("7桁で入力してください。");
    }
    if (post.value.match(/^[0-9]{7}$/) === null) {
      post_arr.push("ハイフン「-」を入れず7桁の半角数字で入力してください。");
    }
    if (post_arr.length !== 0) {
      post.classList.add("b-formInput__error");
      post_er.textContent = post_arr.join("／");
      clear.push("post");
    } else {
      post.classList.remove("b-formInput__error");
    }
  }
  //tel
  if (tel !== null) {
    let tel_arr = [];
    if (tel.value === "") {
      tel_arr.push("入力必須です。");
    }
    if (tel.value.length > 11) {
      tel_arr.push("10〜11桁で入力してください。");
    }
    if (tel.value.match(/^0[0-9]{9,10}$/) === null) {
      tel_arr.push("ハイフン「-」を入れず0からはじまる10〜11桁の半角数字で入力してください。");
    }
    if (tel_arr.length !== 0) {
      tel.classList.add("b-formInput__error");
      tel_er.textContent = tel_arr.join("／");
      clear.push("tel");
    } else {
      tel.classList.remove("b-formInput__error");
    }
  }
  //mail
  if (mail !== null) {
    let mail_arr = [];
    if (mail.value === "") {
      mail_arr.push("入力必須です。");
    }
    if (mail.value.length > 254) {
      mail_arr.push("254文字以内で入力してください。");
    }
    if (mail.value.match(/^[a-zA-Z0-9_+-]+(.[a-zA-Z0-9_+-]+)*@([a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9]*\.)+[a-zA-Z]{2,}$/) === null) {
      mail_arr.push("正しい形式で入力してください。");
    }
    if (mail_arr.length !== 0) {
      mail.classList.add("b-formInput__error");
      mail_er.textContent = mail_arr.join("／");
      clear.push("mail");
    } else {
      mail.classList.remove("b-formInput__error");
    }
  }
  //address1
  if (add_1 !== null) {
    let add_1_arr = [];
    if (add_1.value === "") {
      add_1_arr.push("入力必須です。");
    }
    if (add_1.value.length > 4) {
      add_1_arr.push("4文字以内で入力してください。");
    }
    if (add_1.value.match(/^[ぁ-んァ-ヶｱ-ﾝﾞﾟ一-龠a-zA-Z0-9ａ-ｚＡ-Ｚ０-９\s]*$/) === null) {
      add_1_arr.push("記号は入力できません。");
    }
    if (add_1_arr.length !== 0) {
      add_1.classList.add("b-formInput__error");
      add_1_er.textContent = add_1_arr.join("／");
      clear.push("address");
    } else {
      add_1.classList.remove("b-formInput__error");
    }
  }
  //address2
  if (add_2 !== null) {
    let add_2_arr = [];
    if (add_2.value === "") {
      add_2_arr.push("入力必須です。");
    }
    if (add_2.value.length > 20) {
      add_2_arr.push("20文字以内で入力してください。");
    }
    if (add_2.value.match(/^[ぁ-んァ-ヶｱ-ﾝﾞﾟ一-龠a-zA-Z0-9ａ-ｚＡ-Ｚ０-９\s-ー]*$/) === null) {
      add_2_arr.push("ハイフン「-」以外の記号は入力できません。");
    }
    if (add_2_arr.length !== 0) {
      add_2.classList.add("b-formInput__error");
      add_2_er.textContent = add_2_arr.join("／");
      clear.push("address");
    } else {
      add_2.classList.remove("b-formInput__error");
    }
  }
  //address3
  if (add_3 !== null) {
    let add_3_arr = [];
    if (add_3.value !== "") {
      if (add_3.value.length > 20) {
        add_3_arr.push("20文字以内で入力してください。");
      }
      if (add_3.value.match(/^[ぁ-んァ-ヶｱ-ﾝﾞﾟ一-龠a-zA-Z0-9ａ-ｚＡ-Ｚ０-９\s-ー]*$/) === null) {
        add_3_arr.push("ハイフン「-」以外の記号は入力できません。");
      }
      if (add_3_arr.length !== 0) {
        add_3.classList.add("b-formInput__error");
        add_3_er.textContent = add_3_arr.join("／");
      } else {
        add_3.classList.remove("b-formInput__error");
      }
    } else {
      add_3.classList.remove("b-formInput__error");
    }
  }
  //textarea
  if (text !== null) {
    let text_arr = [];
    if (text.value === "") {
      text_arr.push("入力必須です。");
    }
    if (text.value.length > 1000) {
      text_arr.push("1000文字以内で入力してください。");
    }
    if (text.value.match(/^[^"#$%&'\*\+\-\\/:;<>\[\\\]^_`{|}~]*$/) === null) {
      text_arr.push("一部の半角記号は入力できません。");
    }
    if (text_arr.length !== 0) {
      text.classList.add("b-formInput__error");
      text_er.textContent = text_arr.join("／");
      clear.push("address");
    } else {
      text.classList.remove("b-formInput__error");
    }
  }
  if (clear.length === 0) {
    document.getElementById("submit").click();
  } else {
    window.scrollTo(0, 0);
  }
}
